<template>
    <div class="cookie-icon" @click="$emit('clicked')">
        <MySvg :icon="'cookie'" />
    </div>
</template>


<script>

import MySvg from "../Svg.vue"

export default {
    emits: [
        "clicked",
    ],
    data: () => {
        return {}
    },
    components:{
        MySvg,
    }
}
</script>